mutation resendVerifyEmail($email: String, $username: String) {
    resendVerifyEmail(email: $email, username: $username)
}
